import React from "react"
import {BusinessEntityType, businessEntityTypeLabels} from "../../resources/customer"
import {Editable, EditableDropDownField} from "../HorizontalField/EditableHorizontalField"

export interface EditableBusinessEntityTypeFieldProps {
	entityType?: BusinessEntityType
	setEntityType: (value: BusinessEntityType) => void
	isEditing: boolean
	isDisabled: boolean
	isAllowed: boolean
	isUpdating: boolean
	onStartEdit: () => void
	onCancel: () => void
	update: () => void
	className?: string
}

export function EditableBusinessEntityTypeField(props: EditableBusinessEntityTypeFieldProps) {
	if (props.entityType) {
		return (
			<Editable
				label="Entity Type"
				isEditing={props.isEditing}
				isDisabled={props.isDisabled}
				isAllowed={props.isAllowed}
				isUpdating={props.isUpdating}
				onStartEdit={props.onStartEdit}
				onCancel={props.onCancel}
				setValue={props.setEntityType}
				value={props.entityType}
				initial={props.entityType}
				update={props.update}
				className={props.className}
				possibleValues={businessEntityTypeLabels}
			>
				{EditableDropDownField}
			</Editable>
		)
	}

	return null
}
